import { __ } from '@wordpress/i18n';

const TopUpgradeBanner = () => {
    const { homeSlug: root, imgDir, proActive } = window['JkitDashboardOption'] || {};

    if (proActive) {
        return null;
    }

    const upgradeUrl = `?page=${root || 'jkit'}&utm_source=jeg-elementor-kit&utm_medium=dashboard_top_banner`;

    return (
        <section className="jkit-top-upgrade-banner" aria-label={__('Upgrade to Jeg Kit Pro', 'jeg-elementor-kit')}>
            <div className="jkit-top-upgrade-banner__content">
                <div className="jkit-top-upgrade-banner__copy">
                    <h2>{__('Unlock The Full Experience', 'jeg-elementor-kit')}</h2>
                    <p>
                        {__('Upgrade to Pro to enable automatic security patches and instant feature deployments. ', 'jeg-elementor-kit')}
                        <strong>{__('Don\'t leave your site vulnerable to delayed updates.', 'jeg-elementor-kit')}</strong>
                    </p>
                    <a className="jkit-top-upgrade-banner__button upgrade-pro-btn" href={upgradeUrl}>
                        <span>{__('Upgrade to PRO', 'jeg-elementor-kit')}</span>
                        <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                            <path d="M3.25 9.5L2 2.625L5.4375 5.75L7.625 2L9.8125 5.75L13.25 2.625L12 9.5H3.25ZM12 11.375C12 11.75 11.75 12 11.375 12H3.875C3.5 12 3.25 11.75 3.25 11.375V10.75H12V11.375Z" fill="currentColor" />
                        </svg>
                    </a>
                    <img className="jkit-top-upgrade-banner__arrow" src={`${imgDir}/admin/pro-banner-dashboard/arrow.png`} alt="" aria-hidden="true" />
                </div>
                <div className="jkit-top-upgrade-banner__art" aria-hidden="true">
                    <div className="jkit-top-upgrade-banner__asset jkit-top-upgrade-banner__asset--deployment">
                        <img src={`${imgDir}/admin/pro-banner-dashboard/icon-instant-deployment.svg`} alt="" />
                        <span>{__('Instant Deployment', 'jeg-elementor-kit')}</span>
                    </div>
                    <div className="jkit-top-upgrade-banner__asset jkit-top-upgrade-banner__asset--security">
                        <img src={`${imgDir}/admin/pro-banner-dashboard/icon-security-update.svg`} alt="" />
                        <span>{__('Security Update', 'jeg-elementor-kit')}</span>
                    </div>
                    <div className="jkit-top-upgrade-banner__mockup">
                        <img src={`${imgDir}/admin/pro-banner-dashboard/mockup.webp`} alt="" />
                    </div>
                    <div className="jkit-top-upgrade-banner__asset jkit-top-upgrade-banner__asset--badge">
                        <span>{__('100+', 'jeg-elementor-kit')}</span>
                        <span>{__('Premium Demo', 'jeg-elementor-kit')}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TopUpgradeBanner;
